import { render, staticRenderFns } from "./SettingSortForm.vue?vue&type=template&id=61c89e04&scoped=true&"
import script from "./SettingSortForm.vue?vue&type=script&lang=js&"
export * from "./SettingSortForm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/setting.css?vue&type=style&index=0&id=61c89e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c89e04",
  null
  
)

export default component.exports